<div id="content" class="allcp-form" ng-controller="SalesMemberController" ng-init="tree()">
    <div ng-include="'modules/customer/partials/top_menu.html'"></div>
    
    <div class="panel-body">
        <div style="width:100%">
            <div class="table-responsive">
                <div class="chart" id="treeview"></div>
            </div>
            <div class="text-center mt50" ng-if="isEmpty">
                <div>
                    <img src="img/empty_page_orange.svg" alt="" width="400px">
                    <br>
                    <h3 style="font-size: 48px;font-weight: 800;">No users yet</h3>
                </div>
            </div>
        </div>
    </div>
</div>
